export default __webpack_public_path__ + "static/Glyph-5a92c0d5f6062cb76481a788e42f5bd3.svg";